var map = {
	"./About.svg": "08c3",
	"./Billing.svg": "015a",
	"./Home.svg": "600f",
	"./Login.svg": "364c",
	"./Misc.svg": "1c2e",
	"./Signup.svg": "a03a",
	"./TransferDetails.svg": "11c9",
	"./Transfers.svg": "3a17",
	"./Upgrade.svg": "062f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cf8";